// Pure curation of the getEnergyLabel callable's result for the "Externe data"
// card. Kept free of fetch/Firebase so every branch is unit-testable; the I/O
// wrapper lives in fetchEnergyLabel.js.
//
// AI-CONTEXT: See docs/features/adress-external-data.md

const selectEnergyLabelFacts = (label) => {
    if (!label || !label.energieklasse) return []

    const facts = [{ label: 'Energielabel', value: label.energieklasse }]

    if (label.geldigTot) facts.push({ label: 'Geldig tot', value: label.geldigTot, unit: 'date' })

    const woningtype = label.gebouwsubtype
        ? `${label.gebouwtype} (${label.gebouwsubtype})`
        : label.gebouwtype
    if (woningtype) facts.push({ label: 'Woningtype', value: woningtype })

    return facts
}

export { selectEnergyLabelFacts }
